<template>
  <div :class="className" :style="{ height: eHeight, width: width }" />
</template>
<script>
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";
import { color } from "@/util/util";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    eHeight: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
    },
    setOptions(data,cntSun) {
      // console.log("数字",cntSun)
      let _this = this;
      let chartStyle = {
        tooltip: {
          trigger: "item",
          backgroundColor: 'rgba(255,255,255,1)'
        },
        legend: {
          show: true,
          left: "60%",
          y: "center",
          //   width: "40%",
          orient: "vertical",
          align: "auto",
          borderRadius: "50%",
          width: '40%',
          itemGap: 20,
          textStyle: {
            color: _this.isbig ? "#AABEFF" : "",
            rich: {
              a: {
                width: 80
                // fontSize: 20,
                // verticalAlign: "top",
                // align: "center",
              },
              b: {
                width: 50,
                // fontSize: 14,
                // align: "center",
                // padding: [0, 10, 0, 0],
                // lineHeight: 25,
              },
              c: {
                width: 50,
                align: "center",
              },
            },
          },
          formatter: function (name) {
            // return name + "28.79％" + "555";
            return `{a|${name}}{b|}`;
          },
        },
        series: [
          {
            name: "工作信息统计",
            type: "pie",
            radius: ["55%", "40%"],
            center: ['25%', '50%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 0,
              // borderColor: '#fff',
              borderColor: _this.isbig ? "#1E3990" : "#fff",
              borderWidth: 2,
            },
            label: {
              normal: {
                show: true,
                position: "center",
                color: "#4c4a4a",
                formatter:
                  "{total|信息总量}" + "\n\r" + "{active|" + cntSun + "}",
                rich: {
                  total: {
                    fontSize: 20,
                    lineHeight: 30,
                    // color: '#454c5c'
                    color: _this.isbig ? "#AABEFF" : "",
                  },
                  active: {
                    fontSize: 16,
                    // color: '#6c7a89',
                    color: _this.isbig ? "#AABEFF" : "",
                    lineHeight: 40,
                  },
                },
              },
              emphasis: {
                //中间文字显示
                show: true,
              },
            },
            lableLine: {
              normal: {
                show: false,
              },
              emphasis: {
                show: true,
              },
              tooltip: {
                show: false,
              },
            },

            // label: {
            //     show: true,
            //     position: 'center',
            //     fontSize:18,
            //     formatter: '{a}\n\n{c}'
            // },
            // emphasis: {
            //     scale:false,
            //     label: {
            //         show: false
            //     }
            // },
            // labelLine: {
            //     show: false
            // },
            data: [
              { value: 1048, name: "防艾宣传", itemStyle: { color: color[0] } },
              {
                value: 735,
                name: "青少年服务",
                itemStyle: { color: color[1] },
              },
              { value: 580, name: "个护健康", itemStyle: { color: color[2] } },
              { value: 484, name: "助残助盲", itemStyle: { color: color[3] } },
              {
                value: 300,
                name: "健康进校园",

              },
              { value: 300, name: "其他", itemStyle: { color: color[5] } },
            ],
          },
        ],
      }
      chartStyle.series[0].data = []
      for (var key in data) {
        let seriesStyle = {
          name: "",
          value: 0,
          itemStyle: { color: color[key] }
        }
        seriesStyle.name = data[key].name
        seriesStyle.value = data[key].value
        chartStyle.series[0].data.push(seriesStyle)
      }
      this.chart.setOption(chartStyle);
    },
  },
};
</script>
